//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showPlanetView: false
        };
    },

    computed: {
        avatar () {
            return this.$store.getters.avatar;
        },
        isGamePaused () {
            return this.$store.getters.isGamePaused;
        },
        planet () {
            let route = this.$router.options.routes.find(route => route.name === this.$store.getters.currentRoute);
            if (route && route.meta && route.meta.week) {
                return this.$store.getters.getPlanetByWeek(route.meta.week);
            }

            return this.$store.getters.getPlanetByWeek(this.$store.getters.currentWeek);
        },
        currentRouteExists () {
            return this.$router.options.routes.some(route => route.name === this.$store.getters.currentRoute);
        },
        currentRoute () {
            return this.$router.options.routes.find(route => route.name === this.$store.getters.currentRoute);
        },
        isCurrentRouteUnlocked () {
            return this.$store.getters.isRouteUnlocked(this.currentRoute);
        },
        currentRouteTimeDifference () {
            return this.$store.getters.routeTimeDifference(this.currentRoute);
        },
        hasUserFinishedGame () {
            return this.$store.getters.hasUserFinishedGame;
        },
        isOnPlanet () {
            return this.isGamePaused || !this.$store.getters.planets.some(planet => planet.route === this.$store.getters.currentRoute);
        },
        smallLabel () {
            return this.isOnPlanet ? this.$lang.get('cockpit.location') : this.$lang.get('cockpit.destination');
        },
        bigLabel () {
            return this.planet && this.planet.name && this.planet.name[this.$lang.locale] ? this.planet.name[this.$lang.locale] : '';
        }
    },

    methods: {
        animateSprite ({ element, event }) {
            element.animationSpeed = 0.015;
        },
        togglePlanetView () {
            this.showPlanetView = !this.showPlanetView;
        },
        async next () {
            if (this.isGamePaused) {
                await this.unpause();
            }

            this.$router.push({ name: 'current' });
        },
        unpause () {
            return new Promise((resolve, reject) => {
                axios.post('game/unpause').then(response => {
                    this.$store.commit('storeGameData', response.data.data);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        }
    }
};
